import { Form, FormSection } from "components/ResumeForm/Form";
import { Input } from "components/ResumeForm/Form/InputGroup";
import RichEditor from "./Form/QuillEditor";
import type { CreateHandleChangeArgsWithDescriptions } from "components/ResumeForm/types";
import { useAppDispatch, useAppSelector } from "lib/redux/hooks";
import { selectLanguages, changeLanguages } from "lib/redux/resumeSlice";
import type { ResumeLanguage } from "lib/redux/types";
import RichEditorWithSuggestions from "./Form/RichEditorWithSuggestions";

export const LanguagesForm = () => {
  const languages = useAppSelector(selectLanguages);
  const dispatch = useAppDispatch();
  const showDelete = languages.length > 1;

  return (
    <Form form="languages" addButtonText="Add Language">
      {languages.map((item, idx) => {
        const { language, level, descriptions } = item;
        const handleLanguageChange = (
          ...[
            field,
            value,
          ]: CreateHandleChangeArgsWithDescriptions<ResumeLanguage>
        ) => {
          dispatch(changeLanguages({ idx, field, value } as any));
        };
        const showMoveUp = idx !== 0;
        const showMoveDown = idx !== languages.length - 1;

        return (
          <FormSection
            key={item.id ?? idx}
            form="languages"
            idx={idx}
            showMoveUp={showMoveUp}
            showMoveDown={showMoveDown}
            showDelete={showDelete}
            deleteButtonTooltipText={"Delete language"}
          >
            <Input
              name="language"
              label="Language"
              placeholder="Japanese, French, German ..."
              value={language}
              onChange={handleLanguageChange}
              labelClassName="col-span-4"
            />
            <Input
              name="level"
              label="Level"
              placeholder="Novice, Intermediate, Advanced, Superior, and Distinguished."
              value={level}
              onChange={handleLanguageChange}
              labelClassName="col-span-4"
            />
            {/* <RichEditor
              name="descriptions"
              value={descriptions}
              onChange={handleLanguageChange}
              labelClassName="col-span-full"
              placeholder="Description"
            /> */}
            <RichEditorWithSuggestions
              name="descriptions"
              value={descriptions}
              onChange={handleLanguageChange}
              placeholder="List your Languages here"
              section="languages"
            />
          </FormSection>
        );
      })}
    </Form>
  );
};
